/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { Helmet } from "react-helmet";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import Dropdown from "react-bootstrap/Dropdown";
import { DownloadCloud, UploadCloud } from "react-feather";
import { Form } from "reactstrap";
import useFetcher from "../../hooks/useFetcher";
import { useAuth } from "../../context/AuthContext";
import { BlurSpinner } from "../../components/BlurSpinner";
import Breadcrumb from "../../components/common/breadcrumb";
import { fetchClientesPaginados, fetchAllClientes, importClientes, importRelevosClientes } from "../../services/clientesServices";
import { LabSelect } from "../../components/course/select";
import usePaging from "../../hooks/usePaging";
import { fetchCasasCentrales } from "../../services/casaCentralServices";
import { fetchSucursales } from "../../services/sucursalServices";
import { fetchRegiones } from "../../services/regionServices";
import { fetchServicios } from "../../services/servicioServices";
import { retriveRegionSucursalOptions } from "../../utils/retriveRegionSucursalOptions";
import modulos from "../../mocks/modulos";
import RelevamientoCNModal from "./RelevamientoCNModal";
import { StyledSpinnerButton, CustomDropdown, SpinnerButtonPrimary } from "../../ui/buttons";
import { tableCustomStyles } from "../../ui/table";
import { CustomLabel } from "../../ui/labels";
import { uploadResponsables } from "../../services/subclientesServices";
import RegistroDeVisitasKPIModal from "./RegistroDeVisitasKPIModal";

const Clientes = ({ history }) => {
  const [allClientes, isLoadingAllClientes] = useFetcher(fetchAllClientes, undefined, "fetchAllClientes");
  const pagingController = usePaging(fetchClientesPaginados);
  const [casasCentrales, isLoadingCasasCentrales] = useFetcher(fetchCasasCentrales, undefined, "fetchCasasCentrales");
  const [regiones, isLoadingRegiones] = useFetcher(fetchRegiones, undefined, "fetchRegiones");
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursales, undefined, "fetchSucursales");
  const [servicios, isLoadingServicios] = useFetcher(fetchServicios, undefined, "fetchServicios");
  const [servicioSelected, setServicioSelected] = useState({ label: "", value: "" });
  const [allClientesSelected, setAllClientesSelected] = useState({ label: "", value: "" });
  const [importClientState, setImportClientState] = useState(false);
  const [importingResponsables, setImportingResponsables] = useState(false);
  const [importRelevosState, setImportRelevosState] = useState(false);
  const [openRelevamientoCNModal, setOpenRelevamientoCNModal] = useState(false);
  const [openRegistroDeVisitasModal, setOpenRegistroDeVisitasModal] = useState(false);
  const { currentUser } = useAuth();
  const isAdmin = currentUser && currentUser.haveAdminAccess(modulos.CLIENTES);
  const isAudit = currentUser && currentUser.haveAuditAccess(modulos.CLIENTES);
  const isGeneral = currentUser && currentUser.haveGeneralAccess(modulos.CLIENTES);

  const serviciosOptions = servicios.map((servicio) => {
    return { label: servicio.text, value: servicio.id };
  });

  const allClientesOptions = allClientes.rows
    ? allClientes.rows.map((razon) => {
        return { label: razon.razonSocial, value: razon.id };
      })
    : [];

  const helperRegionSucursal = retriveRegionSucursalOptions(
    pagingController.query.region,
    pagingController.query.sucursal,
    regiones,
    sucursales,
    casasCentrales,
    isLoadingRegiones || isLoadingSucursales || isLoadingCasasCentrales
  );

  const handleRazonSocialSelectChange = (selected, options) => {
    const newState = { [options.name]: selected ? selected.label : null };
    pagingController.setFilterValue(newState);
    setAllClientesSelected(selected);
  };
  const handleReactSelectChange = (selected, options) => {
    const newState = { [options.name]: selected ? selected.value : null, razonSocial: null };
    pagingController.setFilterValue(newState);
    setAllClientesSelected(null);
  };

  const handleServicioChange = (selected, options) => {
    const newState = { [options.name]: selected ? selected.value : null, razonSocial: null };
    pagingController.setFilterValue(newState);
    setServicioSelected(selected);
    setAllClientesSelected(null);
  };

  const handleClientRowClick = (row) => {
    history.push(`/subclientes?estado=activo&page=1&perpage=10&clientId=${row.id}`);
  };

  // SUBCLIENTES Y RESPONSABLES
  const handleImportClient = async () => {
    setImportClientState(true);
    toast.success("Exportando archivo...");
    await importClientes();
    setImportClientState(false);
  };

  // RELEVOS ADMINISTRATIVOS
  const handleImportRelevos = async () => {
    setImportRelevosState(true);
    toast.success("Exportando archivo...");
    await importRelevosClientes();
    setImportRelevosState(false);
  };
  useEffect(() => {
    if (history) {
      const params = new URLSearchParams(history.location.search);
      const servicio = params.get("servicio");
      const razonSocial = params.get("razonSocial");
      const serviceFounded = servicio && servicios.find((serv) => serv.id === servicio);
      if (serviceFounded) {
        setServicioSelected({ label: serviceFounded.text, value: serviceFounded.id });
      } else {
        setServicioSelected({ label: "", value: "" });
      }
      const razonSocialFounded = allClientes && allClientesOptions.find((raz) => raz.label === razonSocial);
      if (razonSocialFounded) {
        setAllClientesSelected({ label: razonSocialFounded.label, value: razonSocialFounded.value });
      } else {
        setAllClientesSelected({ label: "", value: "" });
      }
    }
  }, [history, pagingController.isLoading]);

  // IMPORTAR RESPONSABLES
  const handleUploadFileButton = () => {
    document.getElementById("upExcel").click();
  };
  const handleUploadReponsablesFromTemplate = async (e) => {
    setImportingResponsables(true);
    const selectedFiles = e.target.files;
    try {
      const response = await uploadResponsables({ files: selectedFiles });
      toast.success(response.message);
    } catch (error) {
      if (error.message) {
        toast.error(error.message);
      } else {
        toast.error("Error desconocido");
      }
    }

    // Reset input
    e.target.value = null;
    setImportingResponsables(false);
  };

  return (
    <>
      {openRelevamientoCNModal && <RelevamientoCNModal toggle={() => setOpenRelevamientoCNModal(!openRelevamientoCNModal)} isOpen={openRelevamientoCNModal} />}
      {openRegistroDeVisitasModal && (
        <RegistroDeVisitasKPIModal toggle={() => setOpenRegistroDeVisitasModal(!openRegistroDeVisitasModal)} isOpen={openRegistroDeVisitasModal} />
      )}
      <Helmet>
        <title>PIN - Clientes</title>
      </Helmet>
      <div style={{ display: "flex", alignItems: "center", position: "absolute", right: "30px", zIndex: "1", marginTop: "30px" }}>
        {!isAudit && (
          <CustomDropdown dropdownStyles={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
            <Dropdown>
              <Dropdown.Toggle className="dropdown-toggle white" id="dropdown-basic">
                Actualización de responsables
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <StyledSpinnerButton
                  className="w-100 mb-2"
                  type="button"
                  onClick={() => (window.location.href = "https://adecco-arg.s3.amazonaws.com/TemplateM_Responsables_Subclientes_AdeccoArg.xlsx")}
                  // disabled={importClientState || importRelevosState}
                >
                  <DownloadCloud className="mr-2" size="20" color="#293134" />
                  Template
                </StyledSpinnerButton>
                <StyledSpinnerButton
                  className="w-100 mb-2"
                  type="button"
                  onClick={handleUploadFileButton}
                  disabled={importingResponsables}
                  isLoading={importingResponsables}
                >
                  <UploadCloud className="mr-2" size="20" color="#293134" />
                  Importar responsables
                </StyledSpinnerButton>
                <Form className="p-absolute" style={{ height: "0px", width: "0px", overflow: "hidden" }}>
                  <input id="upExcel" type="file" onChange={handleUploadReponsablesFromTemplate} multiple accept=".xls, .xlsx" />
                </Form>
              </Dropdown.Menu>
            </Dropdown>
          </CustomDropdown>
        )}

        {isGeneral && (
          <div>
            <SpinnerButtonPrimary
              maxHeight="35px"
              className="ml-2"
              type="button"
              onClick={() => setOpenRegistroDeVisitasModal(!openRegistroDeVisitasModal)}
              disabled={importClientState || importRelevosState}
            >
              Registro de Visitas
            </SpinnerButtonPrimary>
          </div>
        )}

        {(isAdmin || isAudit) && (
          <CustomDropdown dropdownStyles={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
            <Dropdown className="ml-3">
              <Dropdown.Toggle className="dropdown-toggle" id="dropdown-basic">
                Exportar
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <StyledSpinnerButton
                  className="w-100 mb-2"
                  type="button"
                  onClick={() => setOpenRelevamientoCNModal(!openRelevamientoCNModal)}
                  disabled={importClientState || importRelevosState}
                >
                  Relevamiento CN
                </StyledSpinnerButton>
                <StyledSpinnerButton
                  className="w-100 mb-2"
                  type="button"
                  onClick={handleImportClient}
                  disabled={importClientState || importRelevosState}
                  isLoading={importClientState}
                >
                  Subclientes y responsables
                </StyledSpinnerButton>
                <StyledSpinnerButton
                  className="w-100 mb-2"
                  type="button"
                  onClick={handleImportRelevos}
                  disabled={importRelevosState || importClientState}
                  isLoading={importRelevosState}
                >
                  Relevo Administrativo
                </StyledSpinnerButton>
                <StyledSpinnerButton
                  className="w-100 mb-2"
                  type="button"
                  onClick={() => setOpenRegistroDeVisitasModal(!openRegistroDeVisitasModal)}
                  disabled={importClientState || importRelevosState}
                >
                  Registro de Visitas
                </StyledSpinnerButton>
              </Dropdown.Menu>
            </Dropdown>
          </CustomDropdown>
        )}
      </div>
      <Breadcrumb title="Clientes" parent="Sistema de clientes" />
      <BlurSpinner isLoading={pagingController.isLoading || isLoadingAllClientes || isLoadingSucursales}>
        <div className="container-fluid" style={{ fontFamily: "Nunito" }}>
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-3 col-12">
                      <div className="form-group">
                        <CustomLabel htmlFor="region" className="col-form-label pt-0 w-100">
                          Región
                        </CustomLabel>
                        <LabSelect
                          id="region"
                          name="region"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={
                            helperRegionSucursal.regionesOptions.find((option) => {
                              return option.value === helperRegionSucursal.selectedRegion;
                            }) || null
                          }
                          placeholder="Todo"
                          isClearable
                          isLoading={null}
                          options={helperRegionSucursal.regionesOptions}
                        />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <CustomLabel htmlFor="sucursal" className="col-form-label pt-0 w-100">
                          Sucursal
                        </CustomLabel>
                        <LabSelect
                          id="sucursal"
                          name="sucursal"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={
                            helperRegionSucursal.casasAndSucusOptions.find((option) => {
                              return option.value === helperRegionSucursal.selectedSucursal;
                            }) || null
                          }
                          placeholder="Todo"
                          isClearable
                          isLoading={isLoadingSucursales}
                          options={helperRegionSucursal.casasAndSucusOptions}
                        />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <CustomLabel htmlFor="servicio" className="col-form-label pt-0 w-100">
                          Servicio
                        </CustomLabel>
                        <LabSelect
                          id="servicio"
                          name="servicio"
                          className="w-100"
                          onChange={handleServicioChange}
                          value={
                            (servicioSelected &&
                              serviciosOptions.find((option) => {
                                return option.value === servicioSelected.value;
                              })) ||
                            null
                          }
                          placeholder="Todo"
                          isClearable
                          isLoading={isLoadingServicios}
                          options={serviciosOptions}
                        />
                      </div>
                    </div>

                    <div className="col-sm-3">
                      <div className="form-group">
                        <CustomLabel htmlFor="razonSocial" className="col-form-label pt-0 w-100">
                          Razón social
                        </CustomLabel>
                        <LabSelect
                          id="razonSocial"
                          name="razonSocial"
                          className="w-100"
                          onChange={handleRazonSocialSelectChange}
                          value={
                            (allClientesSelected &&
                              allClientesOptions.find((option) => {
                                return option.label === allClientesSelected.label;
                              })) ||
                            null
                          }
                          placeholder="Todos"
                          isClearable
                          isLoading={isLoadingAllClientes}
                          options={allClientesOptions}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive support-table">
                    <DataTable
                      title="Clientes"
                      paginationComponentOptions={{ rowsPerPageText: "Clientes por pagina", rangeSeparatorText: "De" }}
                      noDataComponent={
                        <div className="p-3">
                          <b>No se encontraron Clientes</b>
                        </div>
                      }
                      striped
                      pagination
                      sortServer
                      paginationServer
                      onRowClicked={handleClientRowClick}
                      data={pagingController.data}
                      onSort={pagingController.handleSortsChange}
                      paginationTotalRows={pagingController.totalRows}
                      paginationDefaultPage={parseInt(pagingController.query.page || 1, 10)}
                      onChangeRowsPerPage={pagingController.handleRecordsPerPageChange}
                      paginationPerPage={parseInt(pagingController.query.perpage || 10, 10)}
                      onChangePage={pagingController.handlePageChange}
                      customStyles={tableCustomStyles}
                      columns={[
                        // {
                        //   name: "Región",
                        //   sortable: true,
                        //   center: true,
                        //   id: "region",
                        //   style: {
                        //     cursor: "pointer",
                        //   },
                        // },
                        // {
                        //   name: "Sucursal",
                        //   sortable: true,
                        //   center: true,
                        //   id: "sucursal",
                        //   style: {
                        //     cursor: "pointer",
                        //   },
                        // },
                        // {
                        //   name: "Servicio",
                        //   sortable: true,
                        //   center: true,
                        //   id: "servicio",
                        //   style: {
                        //     cursor: "pointer",
                        //   },
                        // },
                        {
                          name: "Razón Social",
                          selector: (row) => row.razonSocial,
                          // sortable: true,
                          center: true,
                          id: "razonsocial",
                          style: {
                            cursor: "pointer",
                          },
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlurSpinner>
    </>
  );
};

export default withRouter(Clientes);
